{
  "markread": "Mark as read",
  "filter": "Filter",
  "newest": "Newest",
  "unread": "Unread",
  "starred": "Starred",
  "online_count": "Items available on the server",
  "offline_count": "Items available locally",
  "offline_navigation_unavailable": "Switching tags and sources is currently not available in offline mode.",
  "tags": "Tags",
  "alltags": "All tags",
  "timestamp": "{0,date} {0,time}",
  "hours": "{0,plural,one {1 hour},other {# hours}} ago",
  "minutes": "{0,plural,one {1 minute},other {# minutes}} ago",
  "seconds": "{0,plural,one {1 second},other {# seconds}} ago",
  "days": "{0,plural,zero {today},one {yesterday},other {# days ago}}",
  "star": "Star",
  "unstar": "Unstar",
  "mark": "Mark as read",
  "unmark": "Mark as unread",
  "load_img": "Show images",
  "open_window": "Open",
  "next": "Next",
  "share_native_label": "Share",
  "share_diaspora_label": "Share on Diaspora",
  "share_twitter_label": "Share on Twitter",
  "share_facebook_label": "Share on Facebook",
  "share_mastodon_label": "Share on Mastodon",
  "share_pocket_label": "Save to Pocket",
  "share_wallabag_label": "Save to Wallabag",
  "share_wordpress_label": "Share on WordPress",
  "share_mail_label": "Share using e-mail",
  "share_copy_label": "Copy link to clipboard",
  "search_label": "Search term",
  "searchbutton": "Search",
  "searchremove": "Hide search",
  "refreshbutton": "Refresh sources",
  "settingsbutton": "Settings",
  "logoutbutton": "Log out",
  "loginbutton": "Log in",
  "sources": "Sources",
  "sources_loading": "Loading sources…",
  "no_sources": "No sources configured.",
  "source_add": "Add source",
  "source_opml": "or import an OPML file",
  "source_export": "Export sources",
  "source_edit": "Edit",
  "source_filter": "Filter",
  "source_menu": "More actions",
  "source_browse": "Browse",
  "source_delete": "Delete",
  "source_warn": "Really delete this source?",
  "source_deleting": "Deleting source…",
  "source_warn_cancel_dirty": "Discard unsaved changes?",
  "source_new": "New unsaved source",
  "source_title": "Title",
  "source_autotitle_hint": "Leave empty to fetch title",
  "source_tags": "Tags",
  "source_pwd_placeholder": "Not changed",
  "source_comma": "Comma separated",
  "source_select": "Please select source",
  "source_params_loading": "Loading parameters…",
  "source_type": "Type",
  "source_save": "Save",
  "source_cancel": "Cancel",
  "source_saving": "Saving source changes…",
  "source_saved": "Saved",
  "source_last_post": "Last post seen",
  "source_refresh": "Refresh this source",
  "source_go_to_settings": "Open in settings",
  "sources_leaving_unsaved_prompt": "Leave settings with unsaved source changes?",
  "tag_change_color_button_title": "Change color",
  "entries_loading": "Loading entries…",
  "no_entries": "No entries found",
  "more": "More",
  "login": "Log in",
  "login_in_progress": "Trying to log in…",
  "login_username": "Username",
  "login_password": "Password",
  "login_invalid_credentials": "Wrong username/password",
  "login_error_generic": "Could not log in: {errorMessage}",
  "login_offline": "Offline storage",
  "no_title": "No title",
  "experimental": "Experimental",
  "error": "An error occurred",
  "error_unauthorized": "Please {link_begin}sign in{link_end} to continue.",
  "error_check_log_file": "An error occured, please check the log file “{0}”.",
  "error_check_system_logs": "An error occured, please check your system logs.",
  "error_unwritable_logs": "Unable to write logs.",
  "streamerror": "No items loaded, reload?",
  "reload_list": "Reload list",
  "sources_refreshed": "Sources refreshed",
  "app_update": "selfoss has been updated, please reload",
  "app_reload": "Reload",
  "error_session_expired": "Session expired",
  "error_add_source": "Could not add source:",
  "error_edit_source": "Could not save source changes:",
  "error_delete_source": "Could not delete source:",
  "error_load_tags": "Could not load tags:",
  "error_unknown_tag": "Unknown tag:",
  "error_unknown_source": "Unknown source ID:",
  "error_mark_items": "Cannot mark all visible items:",
  "error_mark_item": "Cannot mark/unmark item:",
  "error_star_item": "Cannot star/unstar item:",
  "error_logout": "Could not log out:",
  "error_loading": "Loading error:",
  "error_loading_stats": "Cannot load nav stats:",
  "error_saving_color": "Cannot save new color:",
  "error_refreshing_source": "Cannot refresh sources:",
  "error_sync": "Could not sync last changes from server:",
  "error_offline_storage": "Offline storage error: {0}. Reloading may help. Disabling offline for now.",
  "error_offline_storage_not_available": "Offline storage is not available. Make sure your web browser {0}supports IndexedDB API{1} and, if you are using Google Chrome based browser, that you are not running selfoss in incognito mode.",
  "error_invalid_subsection": "Invalid subsection:",
  "error_configuration": "Unable to load configuration.",
  "error_share_native_abort": "Unable to share item—either there are no share targets, or you cancelled it.",
  "error_share_native": "Unable to share item.",
  "info_url_copied": "URL copied to clipboard.",
  "close_dialog": "Close",
  "close_entry": "Close",
  "article_actions": "Actions",
  "article_reading_time": "{0} min read"
}
